export default __webpack_public_path__ + "static/hoch-d365151d5d317afa58718c5c51fc26e7.png";